const getSortedDataLegends = dataLegends => {
  if (dataLegends && dataLegends.length > 0) {
    if (dataLegends[0].hasOwnProperty('value')) {
      return dataLegends.sort((a, b) => a.value - b.value);
    }
    return dataLegends;
  }
  return [];
};

export default getSortedDataLegends;
